<i class="{{categoryIconName()}}" ></i>